import Vue from 'vue'
import Toast from 'vue-toastification'

// Toast Notification Component Styles
import '@core/scss/vue/libs/toastification.scss'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

/**
 * NOTE: If you are using other transition them make sure to import it in `src/@core/scss/vue/libs/notification.scss` from it's source
 */
Vue.use(Toast, {
  hideProgressBar: true,
  closeOnClick: false,
  closeButton: false,
  icon: false,
  timeout: 3000,
  transition: 'Vue-Toastification__fade',
})

export function hmSuccess(text) {
  Vue.$toast({
    component: ToastificationContent,
    props: {
      title: 'Information',
      icon: 'SunIcon',
      variant: 'success',
      text
    }
  })
}

export function hmError(text) {
  Vue.$toast({
    component: ToastificationContent,
    props: {
      title: 'Attention',
      icon: 'SunIcon',
      variant: 'danger',
      text
    }
  })
}

export function hmWarning(text) {
  Vue.$toast({
    component: ToastificationContent,
    props: {
      title: 'Warning',
      icon: 'SunIcon',
      variant: 'warning',
      text
    }
  })
}

export function hmAskFor(title='Are you sure?', text='You won\'t be able to revert this!') {
  return Vue.swal({
    title,
    text,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    customClass: {
      confirmButton: 'btn btn-primary',
      cancelButton: 'btn btn-outline-danger ml-1'
    },
    buttonsStyling: false
  })
}
